import React, { useState } from "react";
import { Modal, Input } from "@nextui-org/react";
import Button from '@mui/material/Button';
import styles from './table.module.css';
import color from 'color'
export default function TransferAcc(){
    const [visible,setVisible] = useState(false);
    const closeHandler = () => {
        setVisible(false);
        console.log("closed");
    };
    const handleTransferAcc=()=>{
        setVisible(true);
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        bradius: '5px',
        boxShadow: 24,
        p: 4,
      };
    return(
        <div>
            <Button style={{ color: '#b11116', fontSize:"15px" }} fullWidth onClick={handleTransferAcc}><b>Transfer To A/c</b></Button>
            <Modal
          closeButton
          blur
          aria-labelledby="modal-title"
          open={visible}
          onClose={closeHandler}
        >
          
        
            <Modal.Body>
            <table className={styles.table}>
              <thead>
                 <th colSpan={2} style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Account Details</th>
              </thead>
              <tbody>
                <tr>
                    <td ><b>Title Of Account</b></td>
                    <td>Rotary Club Kota</td>
                </tr>
                <tr>
                    <td><b>Bank & Branch</b></td>
                    <td>Uco bank sc kota</td>
                </tr>
                <tr>
                    <td><b>Account No.</b></td>
                    <td>05910110084199</td>
                </tr>
                <tr>
                    <td><b>IFSC Code</b></td>
                    <td>UCBA0000591</td>
                </tr>
              </tbody>
            </table>
         </Modal.Body>
         </Modal>
        </div>
    )
}